import { styled } from '@clickcease/cc-client-components-lib'

export const GetTagSectionContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  borderRight: '1px solid rgba(239, 239, 239, 1)',
  height: '100%',
  overflowX: 'hidden',
})

export const ValidateTagSectionContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingInline: '$4',
})

export const GetTagMethodsContainer = styled('div', {
  display: 'flex',
  flex: 2.3,
  maxHeight: '400px',
  minHeight: '350px',
  overflow: 'hidden',
})

export const GetTagSection = styled('section', {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
})

export const InstructionSection = styled('section', {
  display: 'flex',
  flexDirection: 'column',
  minWidth: '400px',
  flex: 1.3,
})

export const GetTagSectionTitle = styled('div', {
  width: '100%',
  display: 'flex',
  fontSize: '$md',
  fontWeight: 500,
  color: '$mainTextColor',
  marginBottom: '16px',

  ':first-child': {
    marginRight: '8px',
  },
})

export const GetTagSectionNumCircle = styled('span', {
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center',
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)',
  color: '$primaryColor',
})
